define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_deposit/validate_form/local_payment_s",

        initialize: function() {

        }
    });
});
